import { ClientDto } from "../../modules/Admin/ClientManagement/types";
import { activateRootAccount, getActiveSessionKey } from "../../utils/SsoSession";

/**
 * Kartın `href`i buradan gelir, bu yüzden yan etkisi YOKTUR. Orta tık ve "yeni
 * sekmede aç" gerçek bir adres istiyor, oysa hesabı köke döndürmek yalnızca bu
 * sekmeden ayrılırken doğru.
 *
 * returnUrl varken sessionKey eklenmiyor ve adres "&" ile bitiyor: eski ekranın
 * davranışı Bug 37025 kapsamında düzeltilene kadar bilinçli olarak korunuyor.
 */
export function buildPortalUrl(client: ClientDto): string {
  if (!client?.redirectUri || !client.redirectUri.trim()) return "";

  const sessionKey = getActiveSessionKey();
  const returnUrl = new URLSearchParams(window.location.search).get("returnUrl");

  return (
    client.redirectUri +
    (returnUrl ? "?returnUrl=" + returnUrl : "") +
    (returnUrl ? "&" : "?sessionKey=" + sessionKey)
  );
}

/** Aynı sekmede açar. Adres, hesap köke döndürülmeden ÖNCE üretilmek zorunda. */
export function openPortal(client: ClientDto): void {
  const url = buildPortalUrl(client);
  if (!url) return;

  activateRootAccount();
  window.location.href = url;
}

export function getPortalName(client: ClientDto, language: string): string {
  return language?.startsWith("en") && client.name_EN ? client.name_EN : client.name;
}

export function getPortalDescription(client: ClientDto, language: string): string {
  return language?.startsWith("en") && client.description_EN
    ? client.description_EN
    : client.description;
}
